export const coloresRandom: readonly string[] = [
  'bg-sky-600 text-white',
  'bg-green-600 text-white',
  'bg-red-600 text-white',
  'bg-yellow-600 text-white',
  'bg-purple-600 text-white',
  'bg-pink-600 text-white',
  'bg-indigo-600 text-white',
  'bg-gray-600 text-white',
  'bg-teal-600 text-white',
  'bg-orange-600 text-white',
  'bg-cyan-600 text-white',
  'bg-lime-600 text-white',
  'bg-amber-600 text-white',
  'bg-violet-600 text-white',
  'bg-fuchsia-600 text-white',
  'bg-rose-600 text-white',
  'bg-blue-600 text-white',
  'bg-emerald-600 text-white',
  'bg-slate-600 text-white',
  'bg-zinc-600 text-white',
  'bg-neutral-600 text-white',
  'bg-stone-600 text-white',
  'bg-sky-500 text-white',
  'bg-green-500 text-white',
  'bg-red-500 text-white',
  'bg-purple-500 text-white',
  'bg-indigo-500 text-white',
  'bg-sky-700 text-white',
  'bg-green-700 text-white',
  'bg-red-700 text-white',
  'bg-purple-700 text-white',
  'bg-indigo-700 text-white',
  'bg-yellow-400 text-black',
  'bg-amber-400 text-black',
  'bg-lime-400 text-black',
  'bg-cyan-400 text-black',
  'bg-teal-400 text-black',
  'bg-gray-800 text-white',
  'bg-slate-800 text-white',
  'bg-zinc-800 text-white',
  'bg-neutral-800 text-white',
  'bg-stone-800 text-white',
];

const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash;
};

export const micaChat_getColorRandom = (nombre: string): string => {
  const safeNombre = nombre?.trim() ?? '';
  if (!safeNombre) return coloresRandom[0];

  const hash = hashString(safeNombre);
  const index = Math.abs(hash) % coloresRandom.length;
  return coloresRandom[index];
};
